import type { AsyncNamespaceInput } from "./namespace/namespace.types.js";
import type { QueuableFunction } from "./function/function.types.js";
import type {
  NexusSignalDefinition,
  NexusEventListener,
  StartStopNotifier,
  DefineSignalOptions,
} from "./event/event.types.js";
import type { AnyFunction } from "./utils/utils.types.js";

/**
 *
 *
 *
 *
 *
 *
 */
export function defineNamespace<T>(implementation: AsyncNamespaceInput<T>): AsyncNamespaceInput<T> {
  return { ...implementation, [Symbol.onexus.namespace]: true } as never;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function defineFunction<Handler extends AnyFunction>(
  handler: Handler,
): QueuableFunction<Handler> {
  return handler as never;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const defineSignal = <T = void>(
  options?: DefineSignalOptions<T>,
): NexusSignalDefinition<T> => {
  return { [Symbol.onexus.event]: { ...options } } as NexusSignalDefinition<T>;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const defineEvent = <T = void>(
  ...listeners: NexusEventListener<T>[]
): NexusSignalDefinition<T> => defineSignal({ listeners });

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const defineStore = <T = void>(
  detail?: T,
  start?: StartStopNotifier<T>,
): NexusSignalDefinition<T> => defineSignal({ detail, start });
